export { AvatarModule } from './avatar.module';
export { AvatarComponent } from './avatar.component';